export default __webpack_public_path__ + "static/laptop_w.64054bc965251d059186e2873320087e.png";